export function csvCell(value: unknown): string {
  const raw = Array.isArray(value) ? value.join(' | ') : value == null ? '' : String(value);
  let firstVisible = 0;
  while (firstVisible < raw.length && raw.charCodeAt(firstVisible) <= 0x20) firstVisible += 1;
  const firstCharacter = raw[firstVisible];
  const safe = firstCharacter === '=' || firstCharacter === '+' || firstCharacter === '-' || firstCharacter === '@'
    ? `'${raw}`
    : raw;
  return `"${safe.replace(/"/g, '""')}"`;
}

export function csvDocument(headers: readonly unknown[], rows: readonly (readonly unknown[])[]): string {
  return [headers.map(csvCell).join(','), ...rows.map((row) => row.map(csvCell).join(','))].join('\n');
}
